<template>
  <v-dialog v-model="dialog" persistent fullscreen no-click-animation>
    <v-container class="text-center fill-height" fluid justify-center :style="`background:white`">
      <v-row :style="`max-width: 70%`">
        <v-layout align-center justify-center>
          <v-flex shrink>
            <app-icon color="error">warning</app-icon>
          </v-flex>
          <v-flex shrink>
            <h1>WARNING:</h1>
          </v-flex>
        </v-layout>
        <v-layout align-center justify-center>
          <v-card flat>
            <v-card-text
              class="font-weight-regular"
              :style="`font-size: 1.75rem; line-height: 1.5;`"
            >
              You are using an <span class="font-weight-bold">unsupported browser</span>, which may
              lead to unexpected results. Please use the latest version of Chrome, Edge, or Firefox
              for the best experience.
            </v-card-text>
          </v-card>
        </v-layout>
        <v-layout pt-4 justify-center>
          <v-flex shrink>
            <v-btn
              href="mailto:support@paradigm.inc"
              class="contactSupportBtn"
              color="primary"
              outlined
            >
              Contact support
            </v-btn>
          </v-flex>
          <v-flex shrink px-3>
            <app-button @click.stop.prevent="close()">
              Continue
            </app-button>
          </v-flex>
        </v-layout>
      </v-row>
    </v-container>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: true
    }
  },
  methods: {
    close() {
      this.dialog = false
      this.$emit('acknowledgeUnsupportedBrowser')
    }
  }
}
</script>

<style lang="scss" scoped>
.contactSupportBtn {
  text-transform: none !important;
}
</style>
